import { Routes, Route, useNavigationType, useLocation, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useLogin } from './Contexts/AuthProvider/AuthProvider';
import ErrolPage from './pages/enroll/EnrollPage';
import Backoffice from 'pages/backoffice/Backoffice';
import { Policies } from 'pages/policies/Policies';
import { Terms } from 'pages/terms/terms';
import { ForgotPasswordPage } from 'pages/forgot-password/ForgotPassword';
import { BackofficeTermsPolicies } from 'pages/backoffice-terms-policies/BackofficeTermsPolicies';
import GrapesJSEditor from 'pages/editor-backoffice/EditoBackoffice';
import PageViewer from 'pages/iframe-landing/iframeLanding';
import MainLayout from './layouts/MainLayout';
import ProtectedRoute from './components/ProtectedRoute';
import WaitlistTable from './components/WaitlistTable';
import ResponsiveMenu from './components/ResponsiveMenu';

function App() {
  const { user } = useLogin();
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    if (action !== 'POP') {
      window.scrollTo(0, 0);
    }
  }, [action, pathname]);

  useEffect(() => {
    let title = '';
    let metaDescription = '';

    switch (pathname) {
      case '/':
        title = '';
        metaDescription = '';
        break;
    }

    if (title) {
      document.title = title;
    }

    if (metaDescription) {
      const metaDescriptionTag: HTMLMetaElement | null = document.querySelector(
        'head > meta[name="description"]'
      );
      if (metaDescriptionTag) {
        metaDescriptionTag.content = metaDescription;
      }
    }
  }, [pathname]);

  return (
    <Routes>
      {/* Rutas públicas - ToroTMS */}
      <Route element={<MainLayout />}>
        <Route path='/' element={<PageViewer pageId='1' />} />
        <Route path='/feature/dispatch' element={<PageViewer pageId='2' />} />
        <Route path='/feature/invoicing' element={<PageViewer pageId='3' />} />
        <Route path='/feature/driver-pay' element={<PageViewer pageId='4' />} />
        <Route path='/feature/reporting' element={<PageViewer pageId='5' />} />
        <Route path='/implementation' element={<PageViewer pageId='6' />} />
        <Route path='/chemlog-demo-video' element={<PageViewer pageId='7' />} />
        <Route path='/itollz' element={<PageViewer pageId='8' />} />
        <Route path='/support' element={<PageViewer pageId='9' />} />
        <Route path='/enroll' element={<ErrolPage />} />
        <Route path='/reset_password' element={<ForgotPasswordPage />} />
        <Route path='/privacy-policy' element={<BackofficeTermsPolicies />} />
        <Route path='/policies' element={<Policies />} />
        <Route path='/terms' element={<Terms />} />
      </Route>

      {/* Rutas protegidas */}
      <Route
        path="/backoffice"
        element={
          <ProtectedRoute>
            <ResponsiveMenu />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/backoffice/request-list" replace />} />
        <Route path="request-list" element={<Backoffice />} />
        <Route path="editor" element={<GrapesJSEditor />} />
        <Route path="waitlist" element={<WaitlistTable />} />
      </Route>
    </Routes>
  );
}

export default App;
